function NoNotesCard() {
  return (
    <div className="w-full max-w-64 rounded-lg bg-white p-4 flex justify-center">
      <p className="text-primary font-bold text-lg mb-1">No notes found</p>
    </div>
  );
}

export default NoNotesCard;
